module.exports = __webpack_public_path__ + "img/logo_black.f0a42548.png";